import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {super_admin_role_id, admin_role_id ,next_app} from "../../constant";
import { navigateToNextWithSync, getLogoutUrl } from "../../utils/syncUtils";

const DashboardSidebar = ({isOpen, toggleSidebar, isDisable}) => {
	const location = useLocation();
	const logout = () => {
		localStorage.removeItem("auth_token");
		localStorage.removeItem("is_login");
		localStorage.removeItem("first_name");
		localStorage.removeItem("last_name");
		localStorage.removeItem("reviewsData");
		localStorage.removeItem("reviews_addresses_id");
		localStorage.removeItem("role");
		localStorage.removeItem("searchedAddress");
		localStorage.removeItem("verified");
		localStorage.removeItem("badge");
		window.location.href = getLogoutUrl();
		// window.location.href = "/";
	};

	// const [isDisable, setIsDisable] = useState(true);

	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");

	useEffect(() => {
		const loadUserData = () => {
			setFirstName(localStorage.getItem("first_name") || "");
			setLastName(localStorage.getItem("last_name") || "");
		};

		// Load initial data
		loadUserData();

		// Listen for localStorage changes
		const handleStorageChange = (e) => {
			if (e.key === "first_name" || e.key === "last_name") {
				loadUserData();
			}
		};

		// Listen for custom events (for same-tab updates)
		const handleCustomStorageChange = () => {
			loadUserData();
		};

		window.addEventListener("storage", handleStorageChange);
		window.addEventListener("localStorageUpdate", handleCustomStorageChange);

		return () => {
			window.removeEventListener("storage", handleStorageChange);
			window.removeEventListener("localStorageUpdate", handleCustomStorageChange);
		};
	}, []);

	// const userRole = localStorage.getItem("role") == super_admin_role_id ? "Super Admin" : localStorage.getItem("role") == admin_role_id ? "Admin" : "Contractor";

	// Get initials for avatar
	// const getInitials = () => {
	// 	if (firstName && lastName) {
	// 		return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
	// 	} else if (firstName) {
	// 		return firstName.charAt(0).toUpperCase();
	// 	}
	// 	return "U";
	// };

	const menuItems = [
		{
			path: "/contractor-dashboard",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
			label: "Dashboard",
			exact: true,
		},
		{
			path: "/contractor-dashboard/ratings",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			),
			label: "My Ratings",
		},
		{
			path: "/contractor-dashboard/submit-rating",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 5V19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					<path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			),
			label: "Submit Rating",
		},
		{
			path: "/contractor-dashboard/comments",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" />
				</svg>
			),
			label: "My Comments",
		},
		{
			path: "/contractor-dashboard/submit-comment",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" />
					<path d="M12 8V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					<path d="M8 12H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			),
			label: "Submit Comment",
		},
		{
			path: "/contractor-dashboard/my-replies",
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
					<rect width="16" height="16" fill="none" />
					<path
						fill="currentColor"
						d="M1.75 1h8.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 10.25 10H7.061l-2.574 2.573A1.458 1.458 0 0 1 2 11.543V10h-.25A1.75 1.75 0 0 1 0 8.25v-5.5C0 1.784.784 1 1.75 1M1.5 2.75v5.5c0 .138.112.25.25.25h1a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.75.75 0 0 1 .53-.22h3.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25m13 2a.25.25 0 0 0-.25-.25h-.5a.75.75 0 0 1 0-1.5h.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 14.25 12H14v1.543a1.458 1.458 0 0 1-2.487 1.03L9.22 12.28a.749.749 0 0 1 .326-1.275a.75.75 0 0 1 .734.215l2.22 2.22v-2.19a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25Z"
					/>
				</svg>
			),
			label: "My Replies",
		},

		// {
		// 	path: "/contractor-dashboard/activity",
		// 	icon: (
		// 		<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24">
		// 			<rect width="24" height="24" fill="none" />
		// 			<path
		// 				fill="none"
		// 				stroke="currentColor"
		// 				stroke-linecap="round"
		// 				stroke-linejoin="round"
		// 				stroke-width="2"
		// 				d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
		// 			/>
		// 		</svg>
		// 	),
		// 	label: "Address Activity",
		// },
		{
			path: "/contractor-dashboard/notifications",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
			label: "Notifications",
		},

		{
			path: "/contractor-dashboard/feedback",
			icon: (
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
			label: "Feedback",
		},
	];

	const isActiveRoute = (path, exact = false) => {
		if (exact) {
			return location.pathname === path;
		}
		return location.pathname.startsWith(path);
	};

	const verification = localStorage.getItem("verified");
	const badge = localStorage.getItem("badge");

	// const getAction = async () => {
	// 	const response = await GetBusinessVerifiedService();

	// 	if (response.status) {

	// 		const isContractor = response.data.role === "contractor";
	// 		const isVerified = Boolean(response?.data?.verified);

	// 		const shouldDisableNav = response.data.role === "contractor" && !response?.data?.verified;

	// 		setIsDisable(shouldDisableNav);

	// 		if (isContractor && !isVerified && location.pathname !== "/contractor-dashboard/business-verified") {
	// 			window.location.href = "/contractor-dashboard/business-verified";
	// 			return;
	// 		}
	// 	}
	// };

	// useEffect(() => {
	// 	const token = localStorage.getItem("auth_token");
	// 	if (!token) return;
	// 	getAction();
	// }, [location.pathname]);

	return (
		<>
			{/* Mobile Overlay */}
			{isOpen && <div className="dashboard-sidebar-overlay" onClick={toggleSidebar} />}

			{/* Sidebar */}
			<div className={`dashboard-sidebar ${isOpen ? "open" : ""}`}>
				<div className="sidebar-header">
					<a 
						href="/" 
						className="sidebar-logo"
						onClick={(e) => {
							e.preventDefault();
							navigateToNextWithSync("/");
						}}
					>
						<img src={`${process.env.PUBLIC_URL}/img/header-logo.png`} alt="JobSiteRating" className="sidebar-logo-img" />
					</a>
					<button className="sidebar-close-btn d-lg-none" onClick={toggleSidebar}>
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</button>
				</div>

				<nav className="sidebar-nav">
					<ul className="nav-list">
						{menuItems.map((item, index) => (
							<li key={index} className="nav-item">
								<Link
									to={item.path}
									aria-disabled={isDisable}
									className={`nav-link ${isDisable ? "disabled" : ""} ${isActiveRoute(item.path, item.exact) ? "active" : ""}`}
									onClick={(e) => {
										if (isDisable) {
											e.preventDefault();
											return;
										}
										if (window.innerWidth < 992) toggleSidebar();
									}}>
									<span className="nav-icon">{item.icon}</span>
									<span className="nav-label">{item.label}</span>
								</Link>
							</li>
						))}
					</ul>
				</nav>

				<div className="sidebar-footer">
					{/* <Link to="/contractor-dashboard/my-profile" className="user-info mb-3 text-decoration-none"> */}
					{/* <Link className="user-info mb-3 text-decoration-none">
					
						<div className="user-avatar position-relative">
							<span>{getInitials()}</span>
							{verification === "true" && (
								<svg
									className="position-absolute"
									style={{
										top: "-8px",
										right: "-9px",
										background: "#FFF",
										borderRadius: "100px",
									}}
									xmlns="http://www.w3.org/2000/svg"
									width="18"
									height="18"
									viewBox="0 0 24 24">
									<path
										// fill="#ffc107"
										fill="#0d6efd"
										d="M10.95 12.7L9.5 11.275Q9.225 11 8.813 11t-.713.3q-.275.275-.275.7t.275.7l2.15 2.15q.3.3.7.3t.7-.3l4.25-4.25q.3-.3.287-.7t-.287-.7q-.3-.3-.712-.312t-.713.287zm-2.8 9.05L6.7 19.3l-2.75-.6q-.375-.075-.6-.387t-.175-.688L3.45 14.8l-1.875-2.15q-.25-.275-.25-.65t.25-.65L3.45 9.2l-.275-2.825q-.05-.375.175-.688t.6-.387l2.75-.6l1.45-2.45q.2-.325.55-.438t.7.038l2.6 1.1l2.6-1.1q.35-.15.7-.038t.55.438L17.3 4.7l2.75.6q.375.075.6.388t.175.687L20.55 9.2l1.875 2.15q.25.275.25.65t-.25.65L20.55 14.8l.275 2.825q.05.375-.175.688t-.6.387l-2.75.6l-1.45 2.45q-.2.325-.55.438t-.7-.038l-2.6-1.1l-2.6 1.1q-.35.15-.7.038t-.55-.438"
									/>
								</svg>
							)}

							{badge == "true" && (
								<div
									className="position-absolute"
									style={{
										top: "16px",
										right: "35px",
										background: "#FFF",
										borderRadius: "100px",
									}}>
									<img src={`${process.env.PUBLIC_URL}/img/favicon.png`} width={20} />
								</div>
							)}
						</div>

						<div className="user-details">
							<div className="user-name text-capitalize">
								{firstName} {lastName}
							</div>
							<div className="user-role text-capitalize">{userRole}</div>
						</div>
						
					</Link> */}
					<button className="logout-btn" onClick={logout}>
						<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						Logout
					</button>
				</div>
			</div>
		</>
	);
};

export default DashboardSidebar;
